module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARBAMAAAAmgTH3AAAAKlBMVEUAAAD/aZb/aY/6aZH7aY/8aZD9aY/9aZD7aY/8aY/8aY/8aY/9aY/8aY+EXJgPAAAADnRSTlMAESIzRFVmd4iZqrvM3UwhkGcAAABtSURBVAjXY2BgYBBRYAADyeO7DUA041YG5ksgBnsBA4MniMEtwMDAA2ZAMQOnAwODDIjBdJCBYSpYe05KdAGYwVReBDHQvbzcASwzzcW1pxCoqRHEqxFgyARLszcwHIQovACEYLCEoXs3GCwAABUFF2CpmM7oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/reg-hover.png
// module id = 250
// module chunks = 0